import { render, staticRenderFns } from "./ScoreInfo.vue?vue&type=template&id=084e3d53&scoped=true"
import script from "./ScoreInfo.vue?vue&type=script&lang=js"
export * from "./ScoreInfo.vue?vue&type=script&lang=js"
import style0 from "./ScoreInfo.vue?vue&type=style&index=0&id=084e3d53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e3d53",
  null
  
)

export default component.exports